import React, { useEffect, useState } from "react";
import Header from "../../directives/header";
import Footer from "../../directives/footer";
import Sidebar from "../../directives/sidebar";
import DataTable, { createTheme } from "react-data-table-component";
import { Link, useNavigate,useLocation } from "react-router-dom";
import config from "../../coreFIles/config";
import {
  getAllUserKycList,
  userKycStatusAction,
  updateSpvPublishStatus,
} from "../../Action/action";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import customStyles from "../CustomStyles";


createTheme("lightTheme", {
  palette: {
    mode: "light",
    text: {
      primary: "#000000",
      secondary: "#555555",
    },
    background: {
      default: "#0B1739",
    },
    divider: "#cccccc",
    action: {
      active: "rgba(0, 0, 0, 0.54)",
      hover: "rgba(0, 0, 0, 0.08)",
      disabled: "rgba(0, 0, 0, 0.12)",
    },
  },
});

const tableContainerStyle = {
  // maxHeight: '600px',
  border: "1px solid #ddd",
  borderRadius: "4px",
};

const KycList = () => {
const location = useLocation();

  const [searchText, setSearchText] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
const [statusFilter, setStatusFilter] = useState(
  location.state?.status?.toString() || "all"
);

  const navigate = useNavigate();

  const columns = [
    {
      name: "S.No",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: true,
      width: "100px",
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.firstName + " " + row.lastName,
      sortable: true,
      center: true,
      width: "180px",
    },
    {
      name: "Email",
      cell: (row) => row.email,
      center: true,
      width: "250px",
    },
    {
      name: "Phone Number",
      selector: (row) => row.phone,
      center: true,
    },
    {
      name: "Selfie Image",
      selector: (row) => (
        <a href={row.selfieWithId} target="_blank">
          {row.selfieWithId ? (
            <img
              src={row.selfieWithId}
              alt="Selfie"
              className="p-1"
              style={{ width: "50px", height: "50px" }}
            />
          ) : (
            "N/A"
          )}
        </a>
      ),
      center: true,
    },
    {
      name: "Document Front Image",
      selector: (row) => (
        <a href={row.documentFrontId} target="_blank">
          {row.documentFrontId ? (
            <img
              src={row.documentFrontId}
              alt="Document Front"
              className="p-1"
              style={{ width: "50px", height: "50px" }}
            />
          ) : (
            "N/A"
          )}
        </a>
      ),
      center: true,
    },
    {
      name: "Document Back Image",
      selector: (row) => (
        <a href={row.documentBackId} target="_blank">
          {row.documentBackId ? (
            <img
              src={row.documentBackId}
              alt="Document Back"
              className="p-1"
              style={{ width: "50px", height: "50px" }}
            />
          ) : (
            "N/A"
          )}
        </a>
      ),
      center: true,
      width: "190px",
    },
    {
      name: "Kyc Status",
      selector: (row) =>
        row.status === 1 ? (
          <span className="badge bg-warning">Pending</span>
        ) : row.status === 2 ? (
          <span className="badge bg-success">Approved</span>
        ) : (
          <span className="badge bg-danger">Rejected</span>
        ),
      center: true,
    },

    {
      name: "Action",
      width: "250px",
      cell: (row) => (
        <div className="action-buttons my-1 d-flex gap-2 mt-2">
          <button
            onClick={() => handleView(row._id)}
            className="btn btn-sm btn-outline-default"
          >
            <i className="fa fa-eye"></i>
          </button>
          {row.status === 1 && (
            <>
              <div className="d-flex gap-1">
                <button
                  className="btn btn-sm btn-success me-2"
                  onClick={() => handleKycAction(row, 2)}
                >
                  Approve
                </button>

                <button
                  className="btn btn-sm btn-danger me-2"
                  onClick={() => handleKycAction(row, 3)}
                >
                  Reject
                </button>
              </div>
            </>
          )}
        </div>
      ),
      // center: true,
    },
  ];


  useEffect(() => {
  if (location.state?.status) {
    setStatusFilter(location.state.status.toString());
  }
}, [location.state]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoader(true);
        const res = await getAllUserKycList();
        setUsersList(res.data);
        setFilteredData(res.data);
      } catch (error) {
        console.error("Error fetching SPV list:", error);
        toast.error("Failed to load SPV list");
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (searchText) {
      const filtered = usersList.filter((item) =>
        Object.values(item).some(
          (val) =>
            val &&
            val.toString().toLowerCase().includes(searchText.toLowerCase()),
        ),
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(usersList);
    }
  }, [searchText, usersList]);


  useEffect(() => {
  let filtered = usersList;

  // 🔎 Search Filter
  if (searchText) {
    filtered = filtered.filter((item) =>
      Object.values(item).some(
        (val) =>
          val &&
          val.toString().toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  }

  // ✅ Status Filter
  if (statusFilter !== "all") {
    filtered = filtered.filter(
      (item) => item.status === Number(statusFilter),
    );
  }

  setFilteredData(filtered);
}, [searchText, statusFilter, usersList]);


  const handleView = async (id) => {
    navigate(`${config.baseUrl}viewKycUser/${id}`);
  };

  const handleKycAction = async (row, status) => {
    try {
      const confirm = await Swal.fire({
        title: "Confirm Action",
        text: `Are you sure you want to ${
          status == 2 ? "Approve" : "Reject"
        } KYC of this user?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: `Yes, ${status == 2 ? "Approve" : "Reject"} it!`,
        cancelButtonText: "No, cancel",
      });

      if (!confirm.isConfirmed) return;

      const res = await userKycStatusAction({
        _id: row._id,
        status: status,
      });
      if (res.status) {
        toast.success(res.msg);
        const updatedList = await getAllUserKycList();
        setUsersList(updatedList.data);
      }
    } catch (error) {
      toast.error(error.message || "Failed to update status");
    }
  };

  return (
    <div className="wrapper">
      <Toaster />
      <Header />
      <Sidebar />
      <div
        className="content-wrapper"
        style={{ Height: "auto", minHeight: "100%" }}
      >
        <div className="container-full">
          <section className="content">
            <div className="row">
              <div className="col-lg-12 col-12">
                <div className="box">
                  <div className="box-header with-border d-flex justify-content-between align-items-center">
                    <h3 className="box-title" style={{ fontWeight: 600 }}>
                      Users Kyc List
                    </h3>
                    {/* <Link to={`${config.baseUrl}addSpv`}>
                      <button className="btn btn-primary">Add SPV+</button>
                    </Link> */}
                  </div>
                  <div className="box-body">
                  <div className="row mb-3 justify-content-end">
  <div className="col-md-4">
    <input
      type="text"
      className="form-control"
      placeholder="Search Users..."
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
    />
  </div>

  <div className="col-md-3">
    <select
      className="form-control"
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
    >
      <option value="all">All Status</option>
      <option value="1">Pending</option>
      <option value="2">Approved</option>
      <option value="3">Rejected</option>
    </select>
  </div>
</div>

                    {loader ? (
                      <div className="text-center py-5">
                        <h4>
                          <i className="fa fa-spinner fa-spin"></i> &nbsp;
                          Please wait
                        </h4>
                      </div>
                    ) : (
                      <div
                        className="table-responsive"
                        style={tableContainerStyle}
                      >
                        <DataTable
                          columns={columns}
                          data={filteredData}
                          pagination
                          highlightOnHover
                          theme="lightTheme"
                          customStyles={customStyles}
                          fixedHeader
                          onChangePage={(page) => setCurrentPage(page)}
                          onChangeRowsPerPage={(
                            currentRowsPerPage,
                            currentPage,
                          ) => {
                            setRowsPerPage(currentRowsPerPage);
                            setCurrentPage(currentPage);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default KycList;
